
import { Store, ActionTree, ActionContext } from "vuex";
import State from "./state";

/**
 * 修改Sidebar类型
 * @param store 
 * @param accessToken 
 */
export function setSidebar(store: ActionContext<State, any>, type: boolean): void
{
    store.commit("SET_SIDEBAR_TYPE", type);
}

/**
 * 修改为色弱模式
 * @param store 
 * @param weakFlag 
 */
export function toggleWeak(store: ActionContext<State, any>, weakFlag: boolean): void
{
    store.commit("TOGGLE_WEAK", weakFlag);
}

/**
 * 是否打开tab模式
 * @param store 
 * @param bool 
 */
export function toggleMultiTab(store: ActionContext<State, any>, bool: boolean): void
{
    store.commit('TOGGLE_MULTI_TAB', bool)
}

/**
 * 切换整体风格
 * @param store 
 * @param themeColor 
 */
export function toggleTheme(store: ActionContext<State, any>, themeColor: string): void
{
    store.commit('TOGGLE_THEME', themeColor)
}

/**
 * 切换导航模式
 * @param store 
 * @param themeColor 
 */
export function toggleLayoutMode(store: ActionContext<State, any>, mode: string): void
{
    store.commit('TOGGLE_LAYOUT_MODE', mode)
}

/**
 * 切换内容宽度
 * @param store 
 * @param themeColor 
 */
export function toggleContentWidth(store: ActionContext<State, any>, type: string): void
{
    store.commit('TOGGLE_CONTENT_WIDTH', type)
}

/**
 * 切换主体颜色
 * @param store 
 * @param color 
 */
export function toggleColor(store: ActionContext<State, any>, color: string): void
{
    store.commit('TOGGLE_COLOR', color)
}

/**
 * 是否固定头部
 * @param store 
 * @param fixedHeader 
 */
export function toggleFixedHeader (store: ActionContext<State, any>, fixedHeader: boolean)
{
    if(!fixedHeader)
    {
        store.commit('TOGGLE_FIXED_HEADER_HIDDEN', false);
    }

    store.commit('TOGGLE_FIXED_HEADER', fixedHeader);
}

/**
 * 切换头部是否固定
 * @param store 
 * @param show 
 */
export function toggleFixedHeaderHidden (store: ActionContext<State, any>, show: boolean)
{
    store.commit('TOGGLE_FIXED_HEADER_HIDDEN', show)
}

/**
 * 切换左侧是否固定
 * @param store 
 * @param fixSiderbar 
 */
export function toggleFixSiderbar (store: ActionContext<State, any>, fixSiderbar: boolean)
{
    store.commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar)
}


export default <ActionTree<State, any>>
{
    setSidebar,
    toggleWeak,
    toggleMultiTab,
    toggleTheme,
    toggleLayoutMode,
    toggleContentWidth,
    toggleColor,
    toggleFixedHeader,
    toggleFixedHeaderHidden,
    toggleFixSiderbar
};
